export default {
  setEventExport (state, eventExport) {
    state.eventExport = eventExport
  }
}
